import { IconDefinition } from '@ant-design/icons-angular';
import {
  AimOutline,
  AlertOutline,
  AlignCenterOutline,
  AlignLeftOutline,
  AlignRightOutline,
  AppleFill,
  AppstoreOutline,
  ArrowDownOutline,
  ArrowLeftOutline,
  ArrowRightOutline,
  ArrowUpOutline,
  AudioOutline,
  BarChartOutline,
  BarsOutline,
  BellFill,
  BellOutline,
  BgColorsOutline,
  BlockOutline,
  BoldOutline,
  BookOutline,
  BorderBottomOutline,
  BorderHorizontalOutline,
  BorderLeftOutline,
  BorderOuterOutline,
  BorderOutline,
  BorderRightOutline,
  BorderTopOutline,
  BorderVerticleOutline,
  BranchesOutline,
  BuildOutline,
  BulbFill,
  BulbOutline,
  CalculatorOutline,
  CalendarOutline,
  CameraOutline,
  CaretDownOutline,
  CaretRightOutline,
  CaretUpOutline,
  CheckCircleFill,
  CheckCircleOutline,
  CheckCircleTwoTone,
  CheckOutline,
  CheckSquareOutline,
  ClearOutline,
  ClockCircleFill,
  ClockCircleOutline,
  CloseCircleFill,
  CloseCircleOutline,
  CloseOutline,
  CloudDownloadOutline,
  CloudOutline,
  CloudSyncOutline,
  CodeOutline,
  ColumnHeightOutline,
  ColumnWidthOutline,
  CommentOutline,
  CompassOutline,
  ContactsOutline,
  ContainerOutline,
  ControlOutline,
  CopyOutline,
  CreditCardOutline,
  CustomerServiceOutline,
  DeleteOutline,
  DeploymentUnitOutline,
  DesktopOutline,
  DisconnectOutline,
  DislikeFill,
  DislikeOutline,
  DollarCircleOutline,
  DollarOutline,
  DotChartOutline,
  DoubleLeftOutline,
  DoubleRightOutline,
  DownOutline,
  DownloadOutline,
  DragOutline,
  EditFill,
  EditOutline,
  EllipsisOutline,
  EnterOutline,
  ExclamationCircleOutline,
  ExpandOutline,
  ExperimentOutline,
  ExportOutline,
  EyeInvisibleOutline,
  EyeOutline,
  FieldNumberOutline,
  FieldTimeOutline,
  FileAddFill,
  FileAddOutline,
  FileDoneOutline,
  FileImageOutline,
  FileOutline,
  FilePdfOutline,
  FileProtectOutline,
  FileSearchOutline,
  FileTextFill,
  FileTextOutline,
  FilterFill,
  FilterOutline,
  FireOutline,
  FlagOutline,
  FontSizeOutline,
  ForkOutline,
  FormOutline,
  FullscreenExitOutline,
  FullscreenOutline,
  FunctionOutline,
  FundOutline,
  FundProjectionScreenOutline,
  FunnelPlotOutline,
  GatewayOutline,
  GiftFill,
  GiftOutline,
  GlobalOutline,
  GroupOutline,
  HeatMapOutline,
  HighlightOutline,
  HistoryOutline,
  HolderOutline,
  HomeOutline,
  HourglassOutline,
  IdcardOutline,
  InboxOutline,
  InfoCircleFill,
  InfoCircleOutline,
  InfoOutline,
  ItalicOutline,
  KeyOutline,
  LeftOutline,
  LeftSquareOutline,
  LikeFill,
  LikeOutline,
  LineChartOutline,
  LineOutline,
  LinkOutline,
  LinuxOutline,
  Loading3QuartersOutline,
  LoadingOutline,
  LockOutline,
  LoginOutline,
  LogoutOutline,
  MailOutline,
  MenuOutline,
  MessageOutline,
  MinusOutline,
  MinusSquareOutline,
  MobileOutline,
  MoonOutline,
  MoreOutline,
  NodeIndexOutline,
  PaperClipOutline,
  PauseCircleOutline,
  PauseOutline,
  PhoneOutline,
  PictureOutline,
  PlayCircleFill,
  PlayCircleOutline,
  PlusCircleOutline,
  PlusOutline,
  PlusSquareOutline,
  ProfileOutline,
  PushpinFill,
  PushpinOutline,
  QrcodeOutline,
  QuestionCircleOutline,
  RadarChartOutline,
  RadiusSettingOutline,
  RadiusUpleftOutline,
  ReadOutline,
  RedoOutline,
  ReloadOutline,
  RetweetOutline,
  RightOutline,
  RiseOutline,
  RobotOutline,
  RocketOutline,
  RollbackOutline,
  RotateRightOutline,
  SafetyCertificateFill,
  SafetyCertificateOutline,
  SafetyOutline,
  SaveOutline,
  ScheduleOutline,
  ScissorOutline,
  SearchOutline,
  SelectOutline,
  SendOutline,
  SettingOutline,
  ShareAltOutline,
  ShoppingCartOutline,
  ShoppingOutline,
  SlackOutline,
  SlidersOutline,
  SolutionOutline,
  SortAscendingOutline,
  SortDescendingOutline,
  SoundOutline,
  StarFill,
  StarOutline,
  StopOutline,
  SunOutline,
  SwapOutline,
  SwapRightOutline,
  SyncOutline,
  TableOutline,
  TagOutline,
  TeamOutline,
  ThunderboltFill,
  ThunderboltOutline,
  TranslationOutline,
  TrophyOutline,
  UndoOutline,
  UnlockOutline,
  UnorderedListOutline,
  UpOutline,
  UploadOutline,
  UserAddOutline,
  UserOutline,
  UserSwitchOutline,
  UsergroupAddOutline,
  VerticalAlignTopOutline,
  VideoCameraFill,
  VideoCameraOutline,
  WalletOutline,
  WarningFill,
  WarningOutline,
} from '@ant-design/icons-angular/icons';

export const STATIC_NZ_ICONS: IconDefinition[] = [
  AimOutline,
  AlertOutline,
  AlignCenterOutline,
  AlignLeftOutline,
  AlignRightOutline,
  AppleFill,
  AppstoreOutline,
  ArrowDownOutline,
  ArrowLeftOutline,
  ArrowRightOutline,
  ArrowUpOutline,
  AudioOutline,
  BarChartOutline,
  BarsOutline,
  BellFill,
  BellOutline,
  BgColorsOutline,
  BlockOutline,
  BoldOutline,
  BookOutline,
  BorderBottomOutline,
  BorderHorizontalOutline,
  BorderLeftOutline,
  BorderOuterOutline,
  BorderOutline,
  BorderRightOutline,
  BorderTopOutline,
  BorderVerticleOutline,
  BranchesOutline,
  BuildOutline,
  BulbFill,
  BulbOutline,
  CalculatorOutline,
  CalendarOutline,
  CameraOutline,
  CaretDownOutline,
  CaretRightOutline,
  CaretUpOutline,
  CheckCircleFill,
  CheckCircleOutline,
  CheckCircleTwoTone,
  CheckOutline,
  CheckSquareOutline,
  ClearOutline,
  ClockCircleFill,
  ClockCircleOutline,
  CloseCircleFill,
  CloseCircleOutline,
  CloseOutline,
  CloudDownloadOutline,
  CloudOutline,
  CloudSyncOutline,
  CodeOutline,
  ColumnHeightOutline,
  ColumnWidthOutline,
  CommentOutline,
  CompassOutline,
  ContactsOutline,
  ContainerOutline,
  ControlOutline,
  CopyOutline,
  CreditCardOutline,
  CustomerServiceOutline,
  DeleteOutline,
  DeploymentUnitOutline,
  DesktopOutline,
  DisconnectOutline,
  DislikeFill,
  DislikeOutline,
  DollarCircleOutline,
  DollarOutline,
  DotChartOutline,
  DoubleLeftOutline,
  DoubleRightOutline,
  DownOutline,
  DownloadOutline,
  DragOutline,
  EditFill,
  EditOutline,
  EllipsisOutline,
  EnterOutline,
  ExclamationCircleOutline,
  ExpandOutline,
  ExperimentOutline,
  ExportOutline,
  EyeInvisibleOutline,
  EyeOutline,
  FieldNumberOutline,
  FieldTimeOutline,
  FileAddFill,
  FileAddOutline,
  FileDoneOutline,
  FileImageOutline,
  FileOutline,
  FilePdfOutline,
  FileProtectOutline,
  FileSearchOutline,
  FileTextFill,
  FileTextOutline,
  FilterFill,
  FilterOutline,
  FireOutline,
  FlagOutline,
  FontSizeOutline,
  ForkOutline,
  FormOutline,
  FullscreenExitOutline,
  FullscreenOutline,
  FunctionOutline,
  FundOutline,
  FundProjectionScreenOutline,
  FunnelPlotOutline,
  GatewayOutline,
  GiftFill,
  GiftOutline,
  GlobalOutline,
  GroupOutline,
  HeatMapOutline,
  HighlightOutline,
  HistoryOutline,
  HolderOutline,
  HomeOutline,
  HourglassOutline,
  IdcardOutline,
  InboxOutline,
  InfoCircleFill,
  InfoCircleOutline,
  InfoOutline,
  ItalicOutline,
  KeyOutline,
  LeftOutline,
  LeftSquareOutline,
  LikeFill,
  LikeOutline,
  LineChartOutline,
  LineOutline,
  LinkOutline,
  LinuxOutline,
  Loading3QuartersOutline,
  LoadingOutline,
  LockOutline,
  LoginOutline,
  LogoutOutline,
  MailOutline,
  MenuOutline,
  MessageOutline,
  MinusOutline,
  MinusSquareOutline,
  MobileOutline,
  MoonOutline,
  MoreOutline,
  NodeIndexOutline,
  PaperClipOutline,
  PauseCircleOutline,
  PauseOutline,
  PhoneOutline,
  PictureOutline,
  PlayCircleFill,
  PlayCircleOutline,
  PlusCircleOutline,
  PlusOutline,
  PlusSquareOutline,
  ProfileOutline,
  PushpinFill,
  PushpinOutline,
  QrcodeOutline,
  QuestionCircleOutline,
  RadarChartOutline,
  RadiusSettingOutline,
  RadiusUpleftOutline,
  ReadOutline,
  RedoOutline,
  ReloadOutline,
  RetweetOutline,
  RightOutline,
  RiseOutline,
  RobotOutline,
  RocketOutline,
  RollbackOutline,
  RotateRightOutline,
  SafetyCertificateFill,
  SafetyCertificateOutline,
  SafetyOutline,
  SaveOutline,
  ScheduleOutline,
  ScissorOutline,
  SearchOutline,
  SelectOutline,
  SendOutline,
  SettingOutline,
  ShareAltOutline,
  ShoppingCartOutline,
  ShoppingOutline,
  SlackOutline,
  SlidersOutline,
  SolutionOutline,
  SortAscendingOutline,
  SortDescendingOutline,
  SoundOutline,
  StarFill,
  StarOutline,
  StopOutline,
  SunOutline,
  SwapOutline,
  SwapRightOutline,
  SyncOutline,
  TableOutline,
  TagOutline,
  TeamOutline,
  ThunderboltFill,
  ThunderboltOutline,
  TranslationOutline,
  TrophyOutline,
  UndoOutline,
  UnlockOutline,
  UnorderedListOutline,
  UpOutline,
  UploadOutline,
  UserAddOutline,
  UserOutline,
  UserSwitchOutline,
  UsergroupAddOutline,
  VerticalAlignTopOutline,
  VideoCameraFill,
  VideoCameraOutline,
  WalletOutline,
  WarningFill,
  WarningOutline,
];
